module.exports = __webpack_public_path__ + "static/img/termsofuse-banner.593c673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/termsofuse-banner.png
// module id = c88F
// module chunks = 0